/* istanbul ignore file */

import dynamic from 'next/dynamic';

import type { Transformer } from 'src/types/Transformer';
import type { MasonryCarouselSectionProps } from '../../../components/sections/MasonryCarouselSection/MasonryCarouselSection';
import type { SectionRenderer } from '../../../types/Section';
import { links } from './data';
import type { FakeMasonryCarouselSectionContent } from './types';

/* istanbul ignore next */
export const renderer: SectionRenderer<MasonryCarouselSectionProps> =
  dynamic<MasonryCarouselSectionProps>(() =>
    import('../../../components/sections/MasonryCarouselSection/MasonryCarouselSection').then(
      (mod) => mod.MasonryCarouselSection,
    ),
  );

export const transformer: Transformer<
  FakeMasonryCarouselSectionContent,
  MasonryCarouselSectionProps
> = ({}) => ({
  uid: 'fake-uid',
  renderer,
  props: {
    title: 'Shop by department',
    trackingTitle: 'masonry carousel',
    links,
  },
});
